import { Component, Input } from "@angular/core";

export enum SummaryFieldAppearance {
  Success = 'success',
  Danger = 'danger'
}

export type SummaryFieldAppearanceT = `${SummaryFieldAppearance}`;

@Component({
  selector: 'app-summary-field',
  templateUrl: './summary-field.component.html',
  styleUrls: ['./summary-field.component.scss']
})
export class SummaryFieldComponent {
  @Input() label!: string;
  @Input() text?: string | null = null;
  @Input() addtionalText?: string | null = null;
  @Input() placeholder: string = '-';
  @Input() prefix: string = '';
  @Input() suffix: string = '';
  @Input() appearance: SummaryFieldAppearanceT | null = null;

  get textCss() {
    if (!this.appearance) {
      return '';
    }

    return `text-${this.appearance}`;
  }
}